import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

/**
 * Marca como caducados todos los datos que la pantalla tenga guardados.
 *
 * Las pantallas guardan lo que leen para no volver a pedirlo a cada momento.
 * Eso va bien hasta que se escribe algo: si nadie avisa, la siguiente pantalla
 * enseña la copia vieja. Pasaba al editar un socio, guardar y volver a su
 * ficha: los cambios estaban en la base de datos, pero en pantalla no, y quien
 * lo usara pensaría que no se ha guardado.
 *
 * Las pantallas que se quedan donde están refrescan solo lo suyo, que es más
 * fino. Esto es para las que escriben y NAVEGAN a otro sitio: desde aquí no se
 * sabe que va a mirar el usuario después, y un cambio en un socio mueve su
 * ficha, la lista, el panel de inicio, la caja y las cuotas pendientes.
 *
 * Solo se vuelve a pedir lo que este en pantalla en ese momento, así que
 * llamarlo de más no cuesta apenas.
 */
export function useRefrescarDatos(): () => void {
  const cliente = useQueryClient();
  return useCallback(() => {
    void cliente.invalidateQueries();
  }, [cliente]);
}
